module.exports = __webpack_public_path__ + "img/clip-education.a6c3bd1e.png";